import {Injectable} from "@angular/core";
import {SearchScopeEnum} from "../../shared/enums/search-scope.enum";
import {ConfigurationService} from "../../shared/services/configuration.service";
import {ContentSearchConfigModel} from "../models/search-config/content-search-config.model";

@Injectable({
    providedIn: "root"
})
export class ContentSearchConfigService extends ConfigurationService<ContentSearchConfigModel> {
    private get DEFAULT_SCOPE(): SearchScopeEnum {
        return SearchScopeEnum.Product;
    }

    public getDefaultScope(): SearchScopeEnum {
        return this.DEFAULT_SCOPE;
    }
    public getConfigByScope<TScopeConfig>(scope: SearchScopeEnum): TScopeConfig {
        const configKey = scope.toString().toLocaleLowerCase();
        return this.config.scopes[configKey] as TScopeConfig;
    }
}
